// import  globalMixinMixin   from "../../../lib/globalMixin"
const jwt = require("jsonwebtoken");

export const setOnFullscreen = ({ commit }, payload) => {
    commit("setOnFullscreen", payload)
};

export const setLayoutTitle = ({ commit }, payload) => {
    commit("setLayoutTitle", payload);
};

export const setLayoutBreadcrumbs = ({ commit }, payload) => {
    commit("setLayoutBreadcrumbs", payload);
};

export const setLayoutHomeDoubt = ({ commit }, payload) => {
    commit("setLayoutHomeDoubt", payload);
};

export const setItemsRandomizedStor = ({ commit }, payload) => {
    commit("setItemsRandomizedStor", payload);
};

export const setItemsOrganizedStor = ({ commit }, payload) => {
    commit("setItemsOrganizedStor", payload);
};

export const setSelectedItemMenu = ({ commit }, payload) => {
    commit("setSelectedItemMenu", payload);
};

export const setRegisterTab = ({ commit }, payload) => {
    commit("setRegisterTab", payload);
};
export const setApiDetailsTab = ({ commit }, payload) => {
    commit("setApiDetailsTab", payload);
};

// Api rest Site

export const setAuth = ({ commit }, payload) => {
    try {
        commit("setAuth", payload);
        const decoded = jwt.decode(payload.access_token);
        commit("setDadosUsuario", decoded);
        let usuario = {
            name: decoded.given_name,
            fullName: decoded.name,
            token: payload.access_token,
            id: decoded.sub
        }
        commit("setUser", usuario);
    } catch (error) {
        throw error;
    }
};
export const setUser = ({ commit }, payload) => {
    commit("setUser", payload);
};

export const setlogOut = ({ commit }) => {
    sessionStorage.clear();
    ['site', 'user'].map((item) => {
        localStorage.removeItem(item);
    })
    commit("setUser", { name: null, token: null });
    commit("logOutUserData");
    commit("setAuth", {});
};

export const changeUserData = ({ commit }, payload) => {
    commit("changeUserData", payload);
};

export const haveRole = ({ getters }, route) => {
    if (getters.getRolesUser.length > 0) {
        return getters.getRolesUser.includes(route)
    }
    return false;
};

export const setTermsPoliciesData = ({ commit }, payload) => {
    commit("setTermsPoliciesData", payload);
};

export const setTermsPoliciesAccepetd = ({ commit }, payload) => {
    commit("setTermsPoliciesAccepetd", payload);
};

export const setNoUseCookies = ({ commit }, payload) => {
    commit("setNoUseCookies", payload);
};

export const setIdUserWhoAccepted = ({ commit }, payload) => {
    commit("setIdUserWhoAccepted", payload);
};
export const setCountApproval = ({ commit }, payload) => {
    commit("setCountApproval", payload);
};

export const setProfileSelected = ({ commit }, payload) => {
    commit("setProfileSelected", payload);
};
export const setMenuGroupsActive = ({ state, commit }, item) => {
    let groups = [
        ...state.menuGroupsActive,
        item
    ]
    commit("setMenuGroupsActive", groups);
};
export const setRemoveMenuGroupsActive = ({ commit }, group) => {
    commit("setRemoveMenuGroupsActive", group);
};
export const setResetMenuGroupsActive = ({ commit }) => {
    commit("setMenuGroupsActive", []);
};

export const setHeaderAdminType = ({ commit }, payload) => {
    commit("setHeaderAdminType", payload);
}